import Toolbar from '@mui/material/Toolbar';
import AppBar, { AppBarProps } from '@mui/material/AppBar';
import { Flex } from '@atoms/layout';
import { FaIcon } from '@atoms/icons';
import { ContainedIconButton } from '@atoms/buttons';
import { ProfileMenu } from './profileMenu';
import { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { RefreshButton } from './components/refreshButton';

export const Header = ({ ...props }: AppBarProps) => {
  const [lastUpdate, setLastUpdate] = useState<Date | null>(null);

  useEffect(() => {
    // setup infinite timer as a trigger for state updates
    setInterval(() => {
      setLastUpdate(new Date());
    }, 1000 * 60);
  }, [setLastUpdate]);

  return (
    <AppBar position="fixed" {...props}>
      <Toolbar>
        <Flex justifyContent="space-between" width="100%" alignCenter gap={3}>
          <Stack sx={{ minWidth: '220px' }} spacing={2} direction={'row'}>
            <RefreshButton />
          </Stack>

          <Flex gap={3} alignCenter>
            <Flex gap={1} alignCenter>
              <ContainedIconButton size="small" sx={{ height: '32px' }}>
                <FaIcon name="bell" />
              </ContainedIconButton>
              <ContainedIconButton size="small" sx={{ height: '32px' }}>
                <FaIcon name="circle-question" />
              </ContainedIconButton>
              <ProfileMenu />
            </Flex>
          </Flex>
        </Flex>
      </Toolbar>
    </AppBar>
  );
};
